import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { Section } from '@fiverr-private/layout_components';
import { DEFAULT_FIVERR_LOCALE } from '@fiverr-private/localization';
import { getGigIds as getBrowseHistory } from '../../../logged_out_homepage/utils/browsingHistory';
import { PERSONALIZED_CONTENT, PAGE_NAME } from '../../../logged_out_homepage/utils/constants/recommendations';
import useTranslationToggle from '../../../logged_out_homepage/hooks/useTranslationToggle';
import { TranslationContextProvider } from '../../../logged_out_homepage/context/TranslationContext';
import MachineTranslationButtonWrapper from '../../../logged_out_homepage/shared/MachineTranslationButtonWrapper';
import PersonalizedSection from './PersonalizedSection';

import styles from './styles.module.scss';

const PersonalizedSectionWrapper = () => {
    const { onTranslationToggle, setOriginalContent, translationState } = useTranslationToggle();
    const { personalizedContentMap, showTranslatedContent, isInitialized } = translationState;
    const { locale } = getContext();
    const recommendationsParams = {
        browse_history: getBrowseHistory(),
        pageName: PAGE_NAME,
        funnelName: PERSONALIZED_CONTENT.FUNNEL_NAME,
    };

    const showTranslationButton = locale !== DEFAULT_FIVERR_LOCALE;

    return (
        <TranslationContextProvider
            value={{
                personalizedContentMap,
                showTranslatedContent,
                isInitialized,
                setOriginalContent,
                onTranslationToggle,
            }}
        >
            <Section paddingTop="0" paddingBottom="0" className={styles.personalizedSectionWrapper}>
                {showTranslationButton && <MachineTranslationButtonWrapper />}
                <PersonalizedSection recommendationsParams={recommendationsParams} />
            </Section>
        </TranslationContextProvider>
    );
};

export default PersonalizedSectionWrapper;
